<template>
<div class="mobile_wrap_advanced_text wow fadeInUp">
 <el-row>
  <!-- <el-col :span="2" class="header_block">1111</el-col> -->
  <el-col :span="24" class="header_block" >
    <div class=" server_box" v-for="(item,index) in advancedArray" :key="index">
      <div class=" server_box_center">
        <div class=" server_box_center_img">
          <img :src="item.url" class="img_each"/>
        </div>
        <div class=" server_box_center_text">
          <div class=" server_box_center_title">{{item.title}}</div>
          <div class=" server_box_center_content">{{item.content}}</div>
        </div>
      </div>
    </div>
  </el-col>
  <!-- <el-col :span="2" class="header_block"></el-col> -->
</el-row>
</div>
</template>

<script>
export default {
  name: 'serviceAdvancedText',
  data() {
    return {
      advancedArray:[
        {url:require('@/assets/imgs/dsp01.png'),title:'专业内容团队',content:'拥有优质创意资源，可提供策划创意、脚本撰写，分镜头绘制，视频拍摄制作，动画制作等服务，满足各行业客户创意需求。'},
        {url:require('@/assets/imgs/dsp02.png'),title:'专业制作团队',content:'团队具有八年以上行业经验，斩获多项国内外奖项。'},
        {url:require('@/assets/imgs/dsp03.png'),title:'高效对接流程',content:'7X24小时高效对接，不限次修改，清晰理解客户需求，快速整理解决方案。'},
        {url:require('@/assets/imgs/dsp04.png'),title:'丰富行业经验',content:'目前已服务电商、快消、互联网、娱乐、金融、通信运营商等行业，经验丰富。'},
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_wrap_advanced_text{
  .header_block{
    min-height:10px
  }
   .server_box{
          width:50%;
          height: 175px;
          display:flex;
          justify-content: center;
          float: left;
          margin-bottom: 20px;
   
          .server_box_center{
            width: 100%;
             display:flex;
            justify-content: center;
            .server_box_center_img{
              width: 20%;
              max-width: 120px;
              margin-right: 20px;
              .img_each{
                width: 50px;
                // background: #e91d62;
    border-radius: 50%;
    // width:129px;
    //     height: 129px;
              }
            }
            .server_box_center_title{
              font-size: 16px;
    font-weight: initial;
    font-style: initial;
    font-family: 微软雅黑;
    text-decoration: initial;
    color: #e91d62;
            }
            .server_box_center_text{
              width: 60%;
              .server_box_center_content{
-webkit-background-clip: text;
    color: #999;
    font-size: 12px;
    line-height: 22px;
    margin-top: 12px;
    word-break: break-word;
              }

              


            }
          }
        }
}
</style>


